export default {
  showMenu: false,
  toggleMenuTo: () => { },
  toggleMenu: () => { },
  set: () => { }
}
